<ng-content [@fade]></ng-content>
